module.exports = __webpack_public_path__ + "img/box_driving.56c72e0c.svg";